import styled from 'styled-components';
import {getToken, getSpacing, getPrimitive, getFontWeight} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {dFlexCenter, dFlexBetween, flexColumn, alignCenter} from '../../../../globalVariables/GlobalFlex';

export const footer = styled.div`
    ${dFlexBetween};
    border-top: 1px solid ${getToken('color.border.subtle')};
    padding-top: ${getSpacing('spaceLg')};
    gap: ${getSpacing('spaceLg')};
    ${mobileMedia} {
        ${flexColumn};
        gap: ${getSpacing('spaceMd')};
    }
`;

export const formattingToolbar = styled.div`
    ${dFlexCenter};
    gap: ${getSpacing('spaceMd')};
    ${alignCenter};
`;

export const charCounter = styled.div<{isExceeded: boolean}>`
    font-weight: ${getFontWeight('bold')};
    color: ${p => p.isExceeded ? getPrimitive('reds.red400') : getToken('color.text.default')};
`;
